import { create } from "zustand";

/**
 * Store global de estado de conexión.
 *
 * Se alimenta de dos fuentes:
 *  1. Eventos nativos del browser (`online` / `offline`)  →  gestionados por `useNavigatorOnline`
 *  2. Detección real de fallos de red en `resilientPost`  →  el interceptor llama a
 *     `useConnectionStore.getState().setDetectedOffline(true)` cuando un request falla
 *     sin respuesta del servidor.
 *
 * `detectedOffline = true` indica que se detectó un fallo de red real,
 * incluso si `navigator.onLine` sigue reportando `true`.
 */
interface ConnectionState {
  detectedOffline: boolean;
  setDetectedOffline: (value: boolean) => void;
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  detectedOffline: false,
  setDetectedOffline: (value: boolean) => set({ detectedOffline: value }),
}));
